import { useTranslation } from '../../../i18n/useTranslation';
import { amountValue, formatAgorot } from '../../../Utils/MoneyUtil';
import './MoneyText.css';

/**
 * An amount, isolated.
 *
 * `<bdi>` is the whole point of this component. Inside a Hebrew paragraph,
 * `180 ₪` next to a date renders with its parts reordered unless each number
 * is laid out as one unit. Writing the amount straight into JSX looks fine in
 * English and is wrong in Hebrew, which is exactly the kind of bug that only
 * shows up in one of the two languages.
 */
export function MoneyText({ amount, agorot, className }: {
  amount?: string | number | null | undefined;
  /**
   * The one place decimals are real: a VAT split, frozen in agorot at issue.
   * Passing this instead of `amount` renders the hundredths.
   */
  agorot?: number | null | undefined;
  className?: string;
}) {
  const { tr } = useTranslation();
  const body = agorot !== undefined && agorot !== null
    ? formatAgorot(agorot, tr('currency'))
    : `${amountValue(typeof amount === 'number' ? String(amount) : amount).toLocaleString('en-US')} ${tr('currency')}`;
  return <bdi className={className ? `money ${className}` : 'money'}>{body}</bdi>;
}
